// Contrail V3.9.0 — tail lengths in seconds (15 s – 4 h). devices.tail_seconds; old tail_minutes is the fallback.
export const TAIL_SECONDS = [15, 30, 60, 120, 300, 600, 900, 1800, 3600, 7200, 14400];
export const tailSec = (d: { tail_seconds?: number | null; tail_minutes?: number | null }) => d.tail_seconds ?? (d.tail_minutes ?? 10) * 60;
export function tailLabel(s: number) {
  if (s < 60) return `${s} seconds`;
  if (s < 3600) return `${s / 60} minute${s === 60 ? "" : "s"}`;
  return `${s / 3600} hour${s === 3600 ? "" : "s"}`;
}
/** Points inside the window [from, now]; the first one is interpolated exactly at `from`, so even a 15 s tail shows
 *  the latest movement when the tracker reports less often than that. */
export function clipTail(pts: [number, number, number][], from: number): [number, number, number][] {
  const i = pts.findIndex((p) => p[2] >= from);
  if (i < 0) return pts.length ? [] : [];
  if (i === 0) return pts.slice();
  const a = pts[i - 1], b = pts[i];
  const f = b[2] === a[2] ? 1 : (from - a[2]) / (b[2] - a[2]);
  return [[a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f, from], ...pts.slice(i)];
}
